import Vue from "vue"
import Vuetify from "../../node_modules/vuetify"
import "../../node_modules/vuetify/dist/vuetify.min.css"
import "../../node_modules/@mdi/font/css/materialdesignicons.css"

Vue.use(Vuetify)

// Actual
export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#0b697e", // vert d'eau
        secondary: "#29b6f6", // bleu
        accent: "#f4f5f7", // beige
        error: "#fb5c00", // orange-1
        info: "#0b697e", // primary-color
        success: "#8bbe22", // acc-green
        warning: "#ffc107", // acc-yellow
        cmaj: "#26727f", // blue-2
        cadh: "#37474f", // menu-color
      },
    },
  },
})

// New
// export default new Vuetify({
//   theme: {
//     themes: {
//       light: {
//         primary: "#414a65",
//         secondary: "#ff5252",
//         // accent: "#82B1FF",
//         error: "#ff5252", // secondary-color
//         info: "#414a65", // primary-color
//         success: "#8bbe22", // acc-green
//         warning: "#f5e71b", // acc-yellow
//         cmaj: "#6a7084", // blue-1
//         cadh: "#414a65", // primary
//       },
//     },
//   },
// });
